export default "__VITE_ASSET__6GsJPomr__"